module.exports = __webpack_public_path__ + "img/1.26a7bd18.jpg";